import { layout } from 'src/styles/layout';
import styled, { css } from 'styled-components';

interface LogoSvgProps {
  isAnimated?: boolean;
  isVisible?: boolean;
}

export const LogoSvg = styled.svg<LogoSvgProps>`
  width: 100px;

  > path {
    transition: all 500ms ease-in-out;
  }

  ${({ isVisible, isAnimated }) => {
    if (!isAnimated) return '';

    // waiting for the animation to be triggered
    if (!isVisible) {
      return css`
        > path {
          transform: translateY(100%);
          opacity: 0;
        }
      `;
    }

    let styles = '';

    // Apply animation delay to each path based on its order
    [...Array(6).keys()].forEach((index) => {
      styles += `
        > path.appear-order-${index} {
          transition-delay: ${index * 50}ms;
          transform: translateY(0);
          opacity: 1;
        }
      `;
    });

    return css`
      ${styles}
    `;
  }}

  @media screen and (max-width: ${layout.sm}) {
    width: 88px;
  }
`;
